module.exports = __webpack_public_path__ + "img/23.a71e091c.jpg";